module.exports = __webpack_public_path__ + "img/远程在线监考-图片.cd9397ce.png";